import { useState, useEffect } from 'react';
import { Form, TextInput, TextArea, Button, Loading } from 'carbon-components-react';
import { toaster } from '../../helpers/toaster';

import MyModal from '../../components/Modal/Modal';
import Label from '../../components/Label/Label';

import { addGlossaryTerm, updateGlossaryTerm } from '../../api/glossary';

import './Glossary.scss';

const GlossaryDetailModal = ({
  mode,
  termId = null,
  open = false,
  term = "",
  definition = "",
  supportingInformation = "",
  refreshTerms = () => {},
  onClose = () => {},
}) => {
  const [processing, setProcessing] = useState(false);
  const [termValue, setTermValue] = useState("");
  const [definitionValue, setDefinitionValue] = useState("");
  const [supportingInfoValue, setSupportingInfoValue] = useState("");
  const [modalMode, setModalMode] = useState("");

  const resetModalInfo = () => {
    setTermValue("");
    setDefinitionValue("");
    setSupportingInfoValue("");
  };

  useEffect(() => setTermValue(term), [term, open]);
  useEffect(() => setDefinitionValue(definition), [definition, open]);
  useEffect(() => setSupportingInfoValue(supportingInformation), [supportingInformation, open]);
  useEffect(() => setModalMode(mode), [mode]);

  const getErrorMessage = (error, fallback) => {
    return error?.response?.data?.message || fallback;
  };

  const saveTerm = (e) => {
    e.preventDefault();

    if (!termValue) {
      toaster("Term is required", "warning");
      return;
    }

    setProcessing(true);

    const body = {
      term: termValue,
      definition: definitionValue,
      supporting_information: supportingInfoValue,
    };

    if (modalMode === "create") {
      addGlossaryTerm(body).then(() => {
        toaster("Term added successfully", "success");
        onClose();
        setProcessing(false);
        refreshTerms();
        resetModalInfo();
      }).catch(error => {
        toaster(getErrorMessage(error, "Failed to add term"), "error");
        setProcessing(false);
      });
    } else {
      updateGlossaryTerm(termId, body).then(() => {
        toaster("Term updated successfully", "success");
        setProcessing(false);
        onClose();
        refreshTerms();
        resetModalInfo();
      }).catch(error => {
        toaster(getErrorMessage(error, "Failed to update term"), "error");
        setProcessing(false);
      });
    }
  };

  const btnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft: "18px",
  };

  return (
    <MyModal
      modalHeading={modalMode === "create" ? "Add Term" : "Edit Term"}
      size="sm"
      open={open}
      onRequestClose={() => {
        resetModalInfo();
        onClose();
      }}
    >
      <div className="glossary-modal-content">
        {processing && <Loading />}

        <Form onSubmit={saveTerm}>
          <div className="glossary-part-wrapper">
            <Label>Term*</Label>
            <div className="glossary-input-wrapper">
              <TextInput
                value={termValue}
                onChange={e => setTermValue(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="glossary-part-wrapper">
            <Label>Definition</Label>
            <div className="glossary-input-wrapper">
              <TextArea
                value={definitionValue}
                onChange={e => setDefinitionValue(e.target.value)}
              />
            </div>
          </div>

          <div className="glossary-part-wrapper">
            <Label>Supporting Information</Label>
            <div className="glossary-input-wrapper">
              <TextArea
                value={supportingInfoValue}
                onChange={e => setSupportingInfoValue(e.target.value)}
              />
            </div>
          </div>

          <div className="glossary-modal-footer">
            <Button
              kind="secondary"
              onClick={() => {
                resetModalInfo();
                onClose();
              }}
              style={btnStyle}
            >Cancel</Button>

            <Button
              type="submit"
              kind="primary"
              style={btnStyle}
            >{modalMode === "create" ? "Add Term" : "Save Changes"}</Button>
          </div>
        </Form>
      </div>
    </MyModal>
  );
};

export default GlossaryDetailModal;
